import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../carousel'
import Icon from '../icon';

const ProjectDetail = ({name, images}) => {

  return (
    <section className="project-detail">
      <h3 className="project-detail--name h4">{name}</h3>
      <div className="project-detail--carousel-container">
        <div className="project-detail--carousel-display">
          <Carousel images={images} />
        </div>
      </div>
    </section>
  )
}

export default ProjectDetail;


// WEBPACK FOOTER //
// ./components/project-detail/index.js